import React from 'react'
import { AppHeader } from '../../components/app-header-main'
import { NewFooter } from '../../components/new-footer'
import { useMainPageStyles } from './main-page.component.styles'
import { MainPageFaqSection } from './main-page-components/main-page-faq-section'
import { MainPageJoinHandsSection } from './main-page-components/main-page-join-hands-section'
import { MainPageImpactMetricsSection } from './main-page-components/main-page-impact-metrics-section'
import { MainPageInfoBlock } from './main-page-components/main-page-info-block'
import { MainPageSustainabilitySection } from './main-page-components/main-page-sustainability-section'
import { MainPageStatsSection } from './main-page-components/main-page-stats-section'
import { MainPageStepsSection } from './main-page-components/main-page-steps-section'
import { MainPageWelcomeSection } from './main-page-components/main-page-welcome-section'
import { NonprofitCategoriesSlider } from './main-page-components/nonpofit-categories-slider/nonprofit-categories-slider'
import { MainPageLatestItemsSection } from './main-page-components/main-page-latest-items-section'

export const MainPage: React.FC = () => {
  const classes = useMainPageStyles()

  return (
    <div className={classes.root}>
      {/** Header **/}
      <div className={classes.menuWrapper}>
        <AppHeader logoVariant="onPrimary" />
      </div>

      {/**Info Block**/}
      <MainPageInfoBlock />

      {/** Stats strip (primary gradient) */}
      <MainPageStatsSection />

      {/**Steps Section — How it works */}
      <MainPageStepsSection />

      {/**Nonprofit Categories Slider**/}
      <NonprofitCategoriesSlider />

      {/** Latest marketplace listings (public API) */}
      <MainPageLatestItemsSection />

      {/** Impact metrics — trust & outcomes (illustrated) */}
      <MainPageImpactMetricsSection />

      {/** Sustainability — reuse, lower footprint, circular mindset */}
      <MainPageSustainabilitySection />

      {/**Welcome section */}
      <MainPageWelcomeSection />

      {/** Join Hands */}
      <MainPageJoinHandsSection />

      {/** FAQ / Accordion */}
      <MainPageFaqSection />

      {/** Footer */}
      <NewFooter isSpacer={false} />
    </div>
  )
}
